import React from 'react';
import { cn } from '../../lib/utils';

interface RichTextProps {
  content: any;
  className?: string;
}

export function RichTextContent({ content, className }: RichTextProps) {
  if (!content) return null;

  const renderContent = (item: any) => {
    if (!item) return null;

    switch (item.format) {
      case 'heading':
        return <h3 className="text-lg font-semibold mb-2">{item.text}</h3>;
      case 'paragraph':
        return <p className="text-gray-700 mb-4">{item.text}</p>;
      case 'bullet':
        return <li className="ml-4 text-gray-700">{item.text}</li>;
      case 'blockquote':
        return (
          <blockquote className="border-l-4 border-gray-200 pl-4 my-4 italic text-gray-600">
            {item.text}
          </blockquote>
        );
      case 'metadata':
        return (
          <div className="text-sm text-gray-500 flex items-center gap-2">
            {item.text}
          </div>
        );
      case 'badge':
        return (
          <span className={cn(
            "px-2 py-1 rounded-full text-xs font-medium",
            item.level === 'high' ? "bg-red-100 text-red-800" :
            item.level === 'medium' ? "bg-yellow-100 text-yellow-800" :
            "bg-green-100 text-green-800"
          )}>
            {item.level}
          </span>
        );
      default:
        return null;
    }
  };

  if (Array.isArray(content)) {
    return (
      <div className={className}>
        {content.map((item, index) => (
          <div key={index}>{renderContent(item)}</div>
        ))}
      </div>
    );
  }

  return <div className={className}>{renderContent(content)}</div>;
}